import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Stakeholder: an individual or group affected by, or influential in, an organizational change initiative.',
    name: 'Stakeholders',
    partialId: PartialId.Standard.create('stakeholders'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
